import { Star } from 'lucide-react';

export default function Stars({ value = 0, size = 'w-3.5 h-3.5', onChange, testId }) {
  const interactive = typeof onChange === 'function';
  return (
    <span data-testid={testId} className="inline-flex items-center gap-0.5" aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map(i => {
        const filled = i <= Math.round(value);
        const cls = `${size} transition-colors ${filled ? 'fill-[#C6410E] text-[#C6410E]' : 'text-[#1a1a1a]/25'}`;
        return interactive ? (
          <button key={i} type="button" data-testid={`${testId}-${i}`} onClick={() => onChange(i)} aria-label={`${i} star${i > 1 ? 's' : ''}`} className="hover:scale-110 transition-transform">
            <Star className={cls} />
          </button>
        ) : <Star key={i} className={cls} />;
      })}
    </span>
  );
}
